import React from 'react';
import { IconButton } from '@mui/material';
import AddSparkIcon from 'components/SVG/AddSparkIcon';

type AddSparkStepButtonProps = {
  onClick: () => void;
};

function AddSparkStepButton({ onClick }: AddSparkStepButtonProps) {
  return (
    <span style={{ position: 'relative' }}>
      <IconButton onClick={onClick}>
        <AddSparkIcon />
      </IconButton>
    </span>
  );
}

export default AddSparkStepButton;
